import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17e14c1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-stunt" }
const _hoisted_2 = { class: "add-stunt__header" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "add-stunt__skill" }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  selected: "",
  disabled: "",
  value: undefined
}
const _hoisted_7 = ["value"]
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "add-stunt__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("h2", null, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tmpStunt.name) = $event)),
            placeholder: _ctx.$t('stunt__name'),
            class: "add-stunt__name",
            type: "text"
          }, null, 8, _hoisted_3), [
            [_vModelText, _ctx.tmpStunt.name]
          ])
        ]),
        _createElementVNode("h3", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tmpStunt.skill) = $event)),
            title: _ctx.$t('skill'),
            class: "add-stunt__select"
          }, [
            _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("select-skill")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill) => {
              return (_openBlock(), _createElementBlock("option", {
                key: skill.name,
                value: skill.name
              }, _toDisplayString(skill.localizedName), 9, _hoisted_7))
            }), 128))
          ], 8, _hoisted_5), [
            [_vModelSelect, _ctx.tmpStunt.skill]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("textarea", {
          ref: "textarea",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tmpStunt.description) = $event)),
          placeholder: _ctx.$t('stunt__description'),
          class: "add-stunt__textarea"
        }, null, 8, _hoisted_8), [
          [_vModelText, _ctx.tmpStunt.description]
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_9, [
      (_ctx.mode === 'edit')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            secondary: "",
            title: _ctx.$t('ui-remove'),
            onClick: _ctx.remove
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("ui-remove")), 1)
            ]),
            _: 1
          }, 8, ["title", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        secondary: "",
        title: _ctx.$t('ui-cancel'),
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ui-cancel")), 1)
        ]),
        _: 1
      }, 8, ["title", "onClick"]),
      _createVNode(_component_Button, {
        title: _ctx.$t('ui-save'),
        disabled: !_ctx.isValid,
        onClick: _ctx.update
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ui-save")), 1)
        ]),
        _: 1
      }, 8, ["title", "disabled", "onClick"])
    ])
  ], 64))
}